import URL from './url'
import http from '@/utils/httpUtils'

export default {
  // 查询设置信息
  getFlexLeaveSerring(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_FLEXLEAVE_SETTING, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询值周老师
  getTeachersSchedule(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_SCHEDULED_TEACHERS, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 设置值周信息
  saveTeachersSchedule(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_FLEXLEAVE_EDIT_TURNS, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询学生刷脸设备
  getStudentDevices(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_STUDENTS_DEVICE, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 设置学生刷脸设备
  saveStudentDevices(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SAVE_STUDENTS_SETTING, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询老师刷脸设备
  getTeacherDevices(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_TEACHERS_DEVICE, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 设置老师刷脸设备
  saveTeacherDevices(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SAVE_TEACHERS_SETTING, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 托管配置启用时间
  getTimeOpen(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_FLEXLEAVE_TIMEOPEN, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 设置托管配置启用时间
  editTimeOpen(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_FLEXLEAVE_EDIT_TIMEOPEN, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 设置是否通知
  saveNotifySwitch(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_FLEXLEAVE_EDIT_NOTITY, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 允许家长提前刷脸
  saveAllowGuardianFaceScanAhead(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_FLEXLEAVE_GUARDIAN_SCAN_AHEAD, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询托管学生
  getFlexLeaveStudents(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_FLEXLEAVE_GET_STUDENTS, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 一键通知
  notifyParents(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_NOTIFY_PARENTS, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询通知进度
  getNotifyProgress(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_NOTIFY_PROGRESS, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 学生滞留签到
  flexLeaveCheckIn(postData) {
    return http.post(URL.API_FLEXLEAVE_BIZ_CHECKIN, postData)
  },
  // 获取进出校车辆自动考勤开关
  getAttendanceConfig(postData) {
    return http.post(URL.API_SCHOOL_GET_ATTENDANCE_CONFIG, postData)
  },
  // 获取请假车场设备
  getLeaveSupportConfig(postData) {
    return http.post(URL.API_SCHOOL_GET_LEAVE_SUPPORT_CONFIG, postData)
  },
  // 设置进出校车辆自动考勤开关
  setAttendanceConfig(postData) {
    return http.post(URL.API_SCHOOL_SET_ATTENDANCE_CONFIG, postData)
  },
  // 设置请假车场设备
  setLeaveSupportConfig(postData) {
    return http.post(URL.API_SCHOOL_SET_LEAVE_SUPPORT_CONFIG, postData)
  },
  // 是否已配置教职工请假
  getAbsenceConfig(postData) {
    return http.get(URL.API_SCHOOL_ABSENCE_CONFIG, postData)
  }
}
